// extracted by mini-css-extract-plugin
module.exports = {"arrow":"arrow_arrow__KPBSR","left":"arrow_left__bwb37"};